import React from "react";
import { Link } from "react-router-dom";
import "./LogoSection.scss";

const LogoSection = ({ childcareCentre, match }) => {
  return (
    <>
      <div className="d-flex align-items-center ml-3 mb-3">
        {childcareCentre && childcareCentre.venueImage && (
          <div className="symbol symbol-150 mr-3">
            <img
              className="venue_logo_section"
              src={childcareCentre && childcareCentre.venueImage}
            />
          </div>
        )}
        <div class="symbol symbol-150 mr-3">
          <h3>{childcareCentre && childcareCentre.name}</h3>
          <p>
            {childcareCentre &&
              childcareCentre?.address &&
              childcareCentre?.address +
                ", " +
                childcareCentre?.suburb +
                ", " +
                childcareCentre?.postcode +
                ", " +
                childcareCentre?.state}{" "}
            {childcareCentre &&
              childcareCentre?.latitude &&
              childcareCentre?.longitude && (
                <a
                  target={"_blank"}
                  href={`https://www.google.com/maps/place/${childcareCentre.address}/${childcareCentre.suburb}/${childcareCentre.state}/${childcareCentre.postcode}/${childcareCentre.country}`}
                >
                  View on Map
                </a>
              )}
          </p>
        </div>
      </div>
    </>
  );
};

export default LogoSection;
